<app-header title="SDS" subTitle=""></app-header>

<div class="main-container">
  <div class="header">
    <div class="left-header">
      <span class="page-title-bar">Application Users Detail</span>
      <button
        pButton
        type="submit"
        class="p-button-raised p-button-info p-button-text"
        (click)="navigateToList()"
      >
        <i class="pi pi-arrow-left"></i> Back
      </button>
    </div>
    <div class="right-header">
      <button
        pButton
        type="submit"
        class="save-btn p-button-raised p-button-success p-button-text"
        (click)="onSubmit(userDetails.value)"
      >
        <i class="pi pi-check" style="color: #22c55e"></i> Save
      </button>
      <button
        pButton
        type="submit"
        class="sub-btn p-button-raised p-button-secondary p-button-text"
        (click)="confirmReset()"
      >
        Cancel
      </button>
    </div>
  </div>

  <div class="input-group">
    <form
      [formGroup]="userDetails"
      (ngSubmit)="onSubmit(userDetails.value)"
      class="flex-form"
    >
      <div class="form-row">
        <label for="username" class="required">Username</label>
        <input
          type="text"
          pInputText
          id="username"
          formControlName="username"
          required
          [attr.disabled]="editMode ? true : null"
        />
        <div
          *ngIf="
            userDetails.get('username')?.hasError('required') &&
            userDetails.get('username')?.touched
          "
          class="invalid-feedback"
        >
          Username is required.
        </div>
        <div
          *ngIf="
            userDetails.get('username')?.hasError('containsSpecialCharacter')
          "
          class="invalid-feedback"
        >
          Username cannot contain special characters.
        </div>
      </div>

      <div class="form-row">
        <label for="contactEmail" class="required">Contact Email</label>
        <input
          type="email"
          pInputText
          id="contactEmail"
          formControlName="contactEmail"
          required
        />
        <div
          *ngIf="
            userDetails.get('contactEmail')?.hasError('email') &&
            userDetails.get('contactEmail')?.touched
          "
          class="invalid-email-message"
        >
          Please enter a valid email address.
        </div>
        <div
          *ngIf="
            userDetails.get('contactEmail')?.hasError('required') &&
            userDetails.get('contactEmail')?.touched
          "
          class="invalid-feedback"
        >
          Contact Email is required.
        </div>
      </div>

      <div class="form-row">
        <label for="sinequaProfile" class="required">Sinequa profile</label>
        <input
          type="text"
          pInputText
          id="sinequaProfile"
          formControlName="sinequaProfile"
          required
        />
        <div
          *ngIf="
            userDetails.get('sinequaProfile')?.hasError('required') &&
            userDetails.get('sinequaProfile')?.touched
          "
          class="invalid-feedback"
        >
          Sinequa profile is required.
        </div>
      </div>
      <div class="form-row">
        <label for="company" class="required">Company</label>
        <input
          type="text"
          pInputText
          id="company"
          formControlName="company"
          required
        />
        <div
          *ngIf="
            userDetails.get('company')?.hasError('required') &&
            userDetails.get('company')?.touched
          "
          class="invalid-feedback"
        >
          Company is required.
        </div>
      </div>
      <div class="form-row">
        <label for="password" class="required">Password</label>
        <input
          type="password"
          pInputText
          id="password"
          formControlName="password"
          [attr.required]="!editMode ? true : null"
        />

        <!-- Error messages -->
        <div
          *ngIf="
            userDetails.get('password')?.hasError('required') &&
            userDetails.get('password')?.touched &&
            !editMode
          "
          class="invalid-feedback"
        >
          Password is required.
        </div>

        <div
          *ngIf="userDetails.get('password')?.hasError('minlength')"
          class="invalid-feedback"
        >
          Password must be at least {{ passwordMinLength }} characters long.
        </div>

        <div
          *ngIf="
            userDetails.get('password')?.hasError('pattern') &&
            userDetails.get('password')?.touched &&
            !userDetails.get('password')?.hasError('minlength')
          "
          class="invalid-feedback"
        >
          Password must contain at least 1 number, 1 uppercase letter, 1
          lowercase letter, 1 special character, and must not contain an email
          address.
        </div>

        <!-- Success message -->
        <div
          *ngIf="
            userDetails.get('password')?.valid &&
            userDetails.get('password')?.touched
          "
          class="success-feedback"
        >
          <i class="pi pi-check-circle" style="color: #008000"></i>
          Strong Password!
        </div>
      </div>

      <div class="form-row role-row">
        <label class="required">Role</label>
        <div class="radio-group">
          <div class="radio-button">
            <input
              type="radio"
              id="Admin"
              formControlName="role"
              value="Admin"
              required
              name="role"
            />
            <label for="Admin">Admin</label>
          </div>
          <div class="radio-button">
            <input
              type="radio"
              id="User"
              formControlName="role"
              value="User"
              required
              name="role"
              checked
            />
            <label for="User">User</label>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<!-- Confirmation Dialog -->
<p-dialog
  header="Confirmation"
  [(visible)]="displayConfirmationDialog"
  id="dialogId"
  [modal]="true"
  [draggable]="false"
  [closable]="true"
  [styleClass]="'confirmation-dialog'"
  appendTo="body"
>
  <p>Do you want to discard all unsaved changes?</p>
  <p-footer>
    <button
      type="button"
      icon="pi pi-times"
      pButton
      (click)="cancelReset()"
      class="no-btn p-button-raised p-button-success p-button-text"
    >
      <span style="margin-left: 5px">No</span>
    </button>
    <button
      type="button"
      icon="pi pi-check"
      pButton
      (click)="resetFormValues()"
      class="yes-btn p-button-raised p-button-danger p-button-text"
    >
      <span style="margin-left: 5px">Yes</span>
    </button>
  </p-footer>
</p-dialog>
<p-dialog
  header="Confirmation"
  [(visible)]="displayConfirmationDialogFromBack"
  id="dialogId"
  [modal]="true"
  [draggable]="false"
  [closable]="true"
  [styleClass]="'confirmation-dialog'"
  appendTo="body"
>
  <p>Do you want to discard all unsaved changes?</p>
  <p-footer>
    <button
      type="button"
      icon="pi pi-times"
      pButton
      (click)="cancelReset()"
      class="no-btn p-button-raised p-button-success p-button-text"
    >
      <span style="margin-left: 5px">No</span>
    </button>
    <button
      type="button"
      icon="pi pi-check"
      pButton
      (click)="goBack()"
      class="yes-btn p-button-raised p-button-danger p-button-text"
    >
      <span style="margin-left: 5px">Yes</span>
    </button>
  </p-footer>
</p-dialog>
